import React from 'react';
import { StyledIconButton } from './styles';
import { IconButtonProps } from './types';

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ variant = 'default', size = 'md', children, disabled = false, type = 'button', ...props }, ref) => {
    return (
      <StyledIconButton
        ref={ref}
        $variant={variant}
        $size={size}
        disabled={disabled}
        type={type}
        {...props}
      >
        {children}
      </StyledIconButton>
    );
  }
);

IconButton.displayName = 'IconButton';

export type { IconButtonProps, IconButtonVariant, IconButtonSize } from './types';
